import { render } from "./LastCallReasons.vue?vue&type=template&id=29b039bb&scoped=true"
import script from "./LastCallReasons.vue?vue&type=script&lang=js"
export * from "./LastCallReasons.vue?vue&type=script&lang=js"

import "./LastCallReasons.vue?vue&type=style&index=0&id=29b039bb&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b039bb"]])

export default __exports__